import React from "react";
import "./LearningCollaborators.css"; // Reuse layout & styling
import learnImg from "../Images/learning.jpg"; // Replace with a dedicated image if available
import { Link } from 'react-router-dom';

const LearningCollaborators = () => {
  return (
    <main className="sh-landing-container">
      <br /><br /><br /><br /><br />

      {/* Learning Collaborators Section */}
      <section className="sh-section12 reverse">
        <div className="sh-img-left-int">
          <img src={learnImg} alt="Learning Collaborator" />
        </div>
        <div className="sh-text-right-int">
          <h2>LEARNING COLLABORATORS</h2>
          <p className="tag">Deliver real-world learning that translates into real placement outcomes</p>
          <p className="tag1">
            Empowering Trainers, <br />Creators & Instructors
            Bootcamp Hosts & <span className="hh">Domain Educators</span>
          </p>

          <p className="tag2">
            We’re enabling practical, placement-driven learning and we need experts like you to make it happen.
            Deliver targeted workshops, hands-on projects, and micro-courses for specific job roles that help our learners get hired.
          </p>
          {/* <a
              href="https://forms.gle/B9ZHm3azzM9suzsN9"
              target="_blank"
              rel="noopener noreferrer"
            > */}
          <Link to="/RedirectToForm"><button className="sh-secondary-btn">Connect Now</button></Link>
          {/* </a> */}
        </div>
      </section>
    </main>
  );
};

export default LearningCollaborators;
